<script setup>
import { Head } from "@inertiajs/vue3";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    title: String,
    additional: Object,
});

const breadcrumbs = [
    {
        url: "#",
        label: "Dashboard",
    },
];
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />
        <div class="card">
            <div class="card-body">
                <iframe
                    title="RTSA DVS"
                    width="100%"
                    height="700"
                    src="https://app.powerbi.com/view?r=eyJrIjoiODhlNzMyMmQtZDkyNS00Yzc4LWE0MzAtOTc5Nzg3N2VkNzBiIiwidCI6IjNiNmFjMTJhLTgwMDAtNGYwZS1iYmMyLWYwNzhiNTY0NGFlNiIsImMiOjEwfQ%3D%3D"
                    allowFullScreen="true"
                ></iframe>
            </div>
        </div>
    </div>
</template>
